import { render, staticRenderFns } from "./BreakdownList.vue?vue&type=template&id=8fc40b64&scoped=true&"
import script from "./BreakdownList.vue?vue&type=script&lang=js&"
export * from "./BreakdownList.vue?vue&type=script&lang=js&"
import style0 from "./BreakdownList.vue?vue&type=style&index=0&id=8fc40b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc40b64",
  null
  
)

export default component.exports